import { useQuery } from '@tanstack/react-query';
import { fetchAllTeamsForHr } from '../../api/queries';

export const GetAllTeamsForHrQueryKey = 'GET_ALL_TEAMS_FOR_HR';

export const useGetAllTeamsForHrQuery = () => {
  return useQuery({
    queryKey: [GetAllTeamsForHrQueryKey],
    queryFn: fetchAllTeamsForHr,
  });
};
